import { BehaviorSubject } from 'rxjs';
import { propComparator } from '@fi-shared/utils/array-sort-comparators';
import { isDefined } from '@fi-shared/utils';

export interface IDropdownSettingsModelV2 {
    dataTextField?: string;
    dataValueField?: string;
    dataValueParentField?: string;
    filterBy?: string | string[];
    orderBy?: string;
}

export class DropdownSettingsModelV2<T> {
    private _dataSet$ = new BehaviorSubject<T[]>([]);
    dataTextField: string = 'Name';
    dataValueField: string = 'Id';
    dataValueParentField: string;
    filterBy: string | string[]; //Specify property name to filter by. Not specified = filter by all properties
    orderBy: string;

    constructor(settings?: IDropdownSettingsModelV2) {
        Object.assign(this, settings);
    }

    get dataSet$(): BehaviorSubject<T[]> {
        return this._dataSet$;
    }
    get dataSet(): T[] {
        return this._dataSet$.value;
    }

    setDataSet(dataSet: T[]) {
        this._dataSet$.next(isDefined(this.orderBy) ? this.getSortedData(dataSet) : dataSet);
    }

    private getSortedData(dataSet: T[]): T[] {
        return dataSet.sort(propComparator(this.orderBy));
    }
}

export class DropdownListSettingsLanguageModel<T> extends DropdownSettingsModelV2<T> {
    filterBy = 'Name';
    defaultLanguageId = null;
}
